module.exports = __webpack_public_path__ + "media/images/number_8_red-acf6f7e45f0423b84cbfc00bcc98d1d4.png";